<h1 mat-dialog-title class="text-center pm-dialog-title">{{'Language.SetRateSelectionText' | translate}}</h1>
<div mat-dialog-content class="contentt">
    <div class="cp-dialog">
        <div class="d-flex mb-2 field-bottom-0">
            <div class="w-month pe-2">
                <mat-form-field appearance="fill" appearance="outline">
                    <input matInput [matDatepicker]="picker" readonly [(ngModel)]="this.local_data.FromDate"
                        name="startDate">
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <i-feather class="t-icon pt-2" name="arrow-right"></i-feather>
            <div class="w-month ps-2">
                <mat-form-field appearance="fill" appearance="outline">
                    <input matInput [matDatepicker]="picker1" readonly [(ngModel)]="this.local_data.ToDate"
                        name="endDate">
                    <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 tabledesign updateexchangerate field-bottom-0">
                <table mat-table [dataSource]="this.local_data.displayCol">
                    <!-- Department Name -->
                    <ng-container matColumnDef="currency">
                        <th mat-header-cell *matHeaderCellDef>
                            {{'Language.CurrencyText' | translate}}

                        </th>
                   
                        <td mat-cell *matCellDef="let item;" class="er-date" >
                             <!-- <ng-container *ngIf="item !== 'Date'"> -->
                            {{item}}
                        <!-- </ng-container> -->
                    </td>
                           
                    </ng-container>

                    <!-- Department Description -->
                    <ng-container matColumnDef="update_new_rate">
                        <th mat-header-cell *matHeaderCellDef>   {{'Language.UpdateNewRateText' | translate}} </th>
                       
                            <td mat-cell *matCellDef="let item">
                                <!-- <ng-container *ngIf="item !== 'Date'"> -->
                                <mat-form-field class="full-width my-2 er-new-rate" appearance="outline">
                                    <input type="text" matInput 
                                        maxlength="10" numbersOnly (blur)="updateColData(item, $event)">
                                </mat-form-field>
                            <!-- </ng-container> -->
                            </td>
                     
                    </ng-container>

                    <!-- Header and Row Declarations -->
                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row class="cursor-pointer" *matRowDef="let row; columns: displayedColumns;"></tr>
              

                </table>

            </div>
            <!-- <div class="col-md-12 text-end">
                <a href="#" class="link">Reset All</a>
            </div> -->
        </div>
    </div>
</div>
<div mat-dialog-actions align="end">
    <button mat-raised-button color="primary" mat-dialog-close (click)="onSave()">{{'Language.UpdateText' | translate}}</button>
    <button mat-raised-button mat-dialog-close>{{'Language.CancelText' | translate}}</button>

</div>